import React, { Component } from "react";
import {
  Row,
  Card,
  CardTitle,
  Form,
  Label,
  Button,
  FormGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  CustomInput,
  Input,
} from "reactstrap";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { registerUser } from "../../redux/actions";
import NewTransportationCompany from "../../components/admin/NewTransportationCompany";
// import IntlMessages from "../../helpers/IntlMessages";
import { Colxx } from "../../components/common/CustomBootstrap";
import axios from "../../containers/api";
import SweetAlert from "react-bootstrap-sweetalert";
import { showCatchError, toEnglishNumbers } from "../../helpers/Utils";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { useHistory } from "react-router-dom";
import { Checkbox } from "@mui/material";
class newregister extends Component {
  constructor(props) {
    super(props);
    this.state = {
      SendActiveCode: true,
      CheckActiveCode: false,
      IsActive: false,
      Mobile: "",
      ActiveCode: "",
      Register: false,
      Check: false,
      message: "",
      TransportationCompanyName: "",
      NationalId: "",

      newMemberUsername: "",
      newMemberPassword: "",
      showNewMember: false,
    };
  }
  onUserRegister() {
    if (this.state.email !== "" && this.state.password !== "") {
      this.props.history.push("/");
    }
  }

  SendActivatinCode = () => {
    const model = {
      mobile: toEnglishNumbers(this.state.Mobile),
      code: "",
    };
    if (this.state.Check === false) {
      this.setState({
        message: "برای ادامه ثبت نام ابتدا قوانین را تایید نمایید",
      });
      //console.log(this.state.Check);
      return;
    }

    axios
      .post("api/v1/Assistant/SendActivatinCode", model)
      .then((res) => {
        // this.props.hideSpinner();
        if (res.status === 200 && res.data.data.code == 1) {
          this.setState(
            {
              SendActiveCode: false,
            },
            () => this.SendActivatinCode1(),
          );
        }
      })
      .catch((error) => {
        // this.props.hideSpinner();
        //  this.props.showAlert(showCatchError(error), "error");
        console.log(error.response);
      });
  };
  SendActivatinCode1 = () => {
    this.setState({ CheckActiveCode: true });
  };
  CheckActivatinCode = () => {
    const model = {
      mobile: toEnglishNumbers(this.state.Mobile),
      code: toEnglishNumbers(this.state.ActiveCode),
    };
    //  this.props.showSpinner();
    axios
      .post("api/v1/Assistant/CheckActivatinCode", model)
      .then((res) => {
        // this.props.hideSpinner();
        if (res.data.data.code == 1 && res.data.data.data == true) {
          //  this.props.showAlert(res.data.data.message, "success");

          // this.setState({ CheckActiveCode:false,Register: true });

          this.props.history.push({
            pathname: "/RegisterProductOwner",
            state: [{ mobile: this.state.Mobile }],
          });
        } else this.setState({ CheckActiveCode: true });
        // this.props.showAlert(res.data.data.message, "error");
      })
      .catch((error) => {
        //  this.props.hideSpinner();
        //this.props.showAlert(showCatchError(error), "error");
        console.log(error.response);
      });
  };

  render() {
    return (
      <Row className="justify-content-center align-items-center d-flex mt-5">
        <Colxx xxs="12" md="9">
          <Card className="auth-card">
            <div className="form-side justify-content-center align-items-center d-flex flex-column">
              <div className="logo-single mb-2" />
              <CardTitle className="mb-5">احراز هویت و ثبت نام</CardTitle>
              {this.state.SendActiveCode === true && (
                <div className="d-flex flex-md-row flex-column w-100 justify-content-center">
                  <FormGroup className="w-md-50 w-100 mx-1">
                    <CustomInput
                      checked={this.state.Check}
                      onClick={() =>
                        this.setState({ Check: !this.state.Check, message: "" })
                      }
                      type="checkbox"
                      label=""
                      id="CheckRule"
                    />
                    <p>
                      موافقت خود از{" "}
                      <a
                        href="https://afsharlogistic.com/terms.html"
                        target="_blank"
                        style={{ color: "#e2863b" }}
                      >
                        قوانین
                      </a>{" "}
                      بازارگاه را اعلام میکنم
                    </p>
                    <Label className="text-danger">{this.state.message} </Label>
                    <Label>شماره موبایل</Label>
                    <Input
                      value={this.state.Mobile}
                      maxLength={11}
                      onChange={(e) =>
                        this.setState({ Mobile: e.target.value })
                      }
                    />
                  </FormGroup>
                </div>
              )}

              {this.state.SendActiveCode === true && (
                <div className="d-flex mb-2 mt-4 justify-content-center align-items-center">
                  <Button
                    color="primary"
                    className="btn-lg mx-2"
                    onClick={() => this.SendActivatinCode()}
                  >
                    ارسال كد
                  </Button>
                </div>
              )}
              {this.state.CheckActiveCode === true && (
                <div className="d-flex flex-md-row flex-column w-100 justify-content-center">
                  <FormGroup className="w-md-50 w-100 mx-1">
                    <Label>كد تایید</Label>
                    <Input
                      value={this.state.ActiveCode}
                      maxLength={6}
                      onChange={(e) =>
                        this.setState({ ActiveCode: e.target.value })
                      }
                    />
                  </FormGroup>
                </div>
              )}
              {this.state.CheckActiveCode === true && (
                <div className="d-flex mb-2 mt-4 justify-content-center align-items-center">
                  <Button
                    color="primary"
                    className="btn-lg mx-2"
                    onClick={() => this.CheckActivatinCode()}
                  >
                    احراز هویت
                  </Button>
                </div>
              )}
            </div>
          </Card>
        </Colxx>
      </Row>
    );
  }
}
const mapStateToProps = ({ authUser }) => {
  const { user, loading } = authUser;
  return { user, loading };
};

export default connect(mapStateToProps, {
  registerUser,
})(newregister);
